import DossierTechniqueViewPage from "@features/creation/dossier-techniques/components/DossierTechniqueViewPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/creation/dossier-techniques/$id/view")({
  loader: requirePermission(PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.VIEW),
  staticData: {
    title: "Détail dossier technique",
    icon: Eye,
    permission: PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.VIEW,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: ViewDossierTechniquePage,
});

function ViewDossierTechniquePage() {
  const { id } = useParams({ from: "/_app/creation/dossier-techniques/$id/view" });
  return <DossierTechniqueViewPage id={id} />;
}
